import React, { useRef } from "react";
import { cloneDeep } from "lodash";
import { ActionMenu } from "oolib";

export const ImageActionsMenu = ({
  id,
  invert,
  setUnderEditImageData,
  setImageUnderEdit,
  setShowDeleteImageModal,
  publicUrl,
  imageData,
  handleReplaceSingleImage,
  handleUpload,
  isInRTE
}) => {
  const inputRef = useRef(null);
  return (
    <div style={{ padding: "0.5rem", ...(isInRTE ? {display: 'none'} : {}) }}>
      <input
        ref={inputRef}
        type="file"
        accept={"image/*"}
        onChange={(e) => {
            handleUpload({
            files: e.target.files,
            publicUrlToReplace: publicUrl,
            callback: ({ successfulUploads }) => {
                handleReplaceSingleImage({
                publicUrl,
                newImage: successfulUploads[0],
                });
                //pending
            },
            });
        }}
        style={{ display: "none" }}
        />

      <ActionMenu
        popOutOfOverflowHiddenParent
        ButtonComp="ButtonPrimary"
        iconSize="M"
        invert={invert}
        actions={[
          {
            /**
             * imp. to attach this comp id to this action's id so that when a 
             * click is triggered from outside (ImageInputNode Lexical), it 
             * indeed clicks this button and not the button of some other ImageInput
             */
            id: `${id}_editImage`, 
            display: "Edit",
            onClick: (e) => {
              setUnderEditImageData(cloneDeep(imageData));
              setImageUnderEdit && setImageUnderEdit(true); //comes from ImageInput context if used inside it
            },
          },
          {
            id: `${id}_replaceImage`,
            display: "Replace",
            onClick: () => inputRef.current.click(),
          },
          {
            id: `${id}_deleteImage`,
            display: "Delete",
            onClick: (e) => setShowDeleteImageModal({ publicUrl }),
          },
        ]}
      />
    </div>
  );
};
